const uploadUrl = 'proxy/qcloud/'
const noteUrl = 'proxy/note/'
const versionUrl =  'version/'

const baseUrl =  '//auth.tiansc.top/'
// 页面
const loginUrl = '//gate.tiansc.top/#/login'
const changepasswordUrl = '//gate.tiansc.top/#/login'


// const baseUrl =  '//localhost:9527/'
// // 页面
// const loginUrl = '//localhost:3001/#/login'
// const changepasswordUrl = '//localhost:3001/#/login'
export {baseUrl, versionUrl, uploadUrl, noteUrl, loginUrl, changepasswordUrl};


// WEBPACK FOOTER //
// ./src/config.js